/* Schöne Deko Footer (sdf)
   - Handy: Spalten auf- und zuklappen
   - Einblenden, sobald der Footer ins Bild kommt
   - Blütenblätter, sobald man ganz unten angekommen ist (einmal pro Seitenaufruf)
   - „Nach oben“-Knopf */
(function () {
  var MOBILE = 767;
  var COLORS = ['#c97b6e', '#e3b2a6', '#f3d6cd', '#d99a8c', '#ffffff'];

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initAccordion(root) {
    root.querySelectorAll('.sdf__col-heading').forEach(function (btn) {
      if (btn.dataset.sdfInit) return;
      btn.dataset.sdfInit = '1';
      btn.addEventListener('click', function () {
        if (window.innerWidth > MOBILE) return;
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        if (!body) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        body.classList.toggle('is-open', !isOpen);
      });
    });
  }

  function dropPetals(footer) {
    var layer = footer.querySelector('.sdf__petals');
    if (!layer || layer.dataset.sdfDone) return;
    var mobile = window.innerWidth <= MOBILE;
    var count = parseInt(footer.getAttribute(mobile ? 'data-sdf-petals-mobile' : 'data-sdf-petals'), 10) || 0;
    if (!count) return;
    layer.dataset.sdfDone = '1';

    var rect = footer.getBoundingClientRect();
    var width = footer.clientWidth;
    var height = footer.offsetHeight;
    // Blätter starten am oberen Rand dessen, was gerade zu sehen ist
    var start = Math.max(0, -rect.top);
    var copyright = footer.querySelector('.sdf__copyright');
    var floor = copyright ? copyright.offsetTop + 4 : height - 40;

    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var size = (mobile ? 9 : 10) + Math.round(Math.random() * (mobile ? 9 : 12));
      var land = floor - 10 - Math.round(Math.random() * 46) - start;
      var drift = mobile ? 12 + Math.random() * 20 : 20 + Math.random() * 40;
      var p = document.createElement('span');
      p.className = 'sdf__petal';
      p.style.cssText =
        'top:' + (start - 30) + 'px;' +
        'left:' + Math.round(Math.random() * (width - 24)) + 'px;' +
        'width:' + size + 'px;height:' + Math.round(size * 0.8) + 'px;' +
        'background:' + COLORS[i % COLORS.length] + ';' +
        '--y:' + Math.max(80, land) + 'px;' +
        '--s:' + Math.round(drift) + 'px;' +
        '--e:' + Math.round(Math.random() * (mobile ? 40 : 80) - (mobile ? 20 : 40)) + 'px;' +
        '--r:' + (180 + Math.round(Math.random() * 360)) + 'deg;' +
        '--d:' + (3.8 + Math.random() * 2.6).toFixed(2) + 's;' +
        '--w:' + (Math.random() * 1.8).toFixed(2) + 's';
      frag.appendChild(p);
    }
    layer.appendChild(frag);
  }

  function initAnimation(footer) {
    if (footer.dataset.sdfAnim) return;
    footer.dataset.sdfAnim = '1';
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      footer.classList.add('sdf--in');
      return;
    }
    footer.classList.add('sdf--anim');

    // 1) Inhalt blendet ein, sobald der Footer ins Bild kommt
    var enter = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        footer.classList.add('sdf--in');
        enter.disconnect();
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    enter.observe(footer);

    // 2) Blätter fallen, wenn das Seitenende erreicht ist
    var end = footer.querySelector('.sdf__copyright') || footer;
    var bottom = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        footer.classList.add('sdf--in');
        dropPetals(footer);
        bottom.disconnect();
      });
    }, { threshold: 0.5 });
    bottom.observe(end);
  }

  function initTop(footer) {
    var btn = footer.querySelector('[data-sdf-top]');
    if (!btn || btn.dataset.sdfInit) return;
    btn.dataset.sdfInit = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reducedMotion() ? 'auto' : 'smooth' });
    });
  }

  function init(section) {
    var footer = section.querySelector('.sdf');
    if (!footer) return;
    initAccordion(section);
    initAnimation(footer);
    initTop(footer);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="static-footer"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section-type="static-footer"]');
    if (el) init(el);
  });
})();
